
import Page from '../../../../components/Page'
import sidebar from './sidebar.json'
import content from './content.json'

function DeleteControls() {

    const img1 = require('./assets/delete-control1.png')
    const img2 = require('./assets/delete-control2.png')
    const img3 = require('./assets/delete-control3.png')
    
    content.images = [{
        imageName: img1,
        imageClassName: 'img',
        onClick: () => { }
    },
        {
        imageName: img2,
        imageClassName: 'img',
        onClick: () => { }
    },
        {
        imageName: img3,
        imageClassName: 'img',
        onClick: () => { }}]

    return (<Page sidebar={sidebar} content={content}></Page>);
}

export default DeleteControls